// @flow
import type { Router } from 'app/common/lib/ReactRouter/types';

const Campaigns = {
  adCredits: 'adcredits',
};

export const inAdCreditsCampaign = (router: Router) =>
  router &&
  router.location &&
  router.location.query &&
  router.location.query.utm_medium === Campaigns.adCredits;

export const getCampaignUtmParam = (router: Router) => {
  if (router && router.location && router.location.query && router.location.query.utm_medium) {
    return `utm_medium=${router.location.query.utm_medium}`;
  }
  return '';
};

export default null;
